import { ADD_AFIP, GET_AFIPS, UPLOAD_AFIP } from "./types";

const initialState = {
  afips: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AFIPS:
      return {
        ...state,
        afips: action.payload,
      };
      case UPLOAD_AFIP:
      return {
        ...state,
        loading: action.payload,
      };
    case ADD_AFIP:
      return {
        ...state,
        afips: [...state.afips, action.payload],
      };
    default:
      return state;
  }
};
